import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { getLegalLinks } from '../lib/legalLinks';

const VARIANT_KEYS = {
  create: 'common:legal.accept_create',
  continue: 'common:legal.accept_continue',
  purchase: 'common:legal.accept_purchase',
};

// Shared acceptance line for signup/login/conversion/purchase surfaces.
// Copy, style and link destinations live here only; each surface just picks a variant.
// Named Trans components (termsLink/privacyLink) avoid positional-index coupling
// between the JSX and the translation strings.
export default function LegalAcceptance({ variant = 'continue', className = '' }) {
  const { t, i18n } = useTranslation(['common']);
  const links = getLegalLinks(i18n?.language);
  const linkClass = 'underline underline-offset-2 text-[#8a8a8a] hover:text-[#FF6B00] transition-colors';
  return (
    <p
      className={`text-xs text-[#6a6a6a] text-center leading-relaxed ${className}`.trim()}
      data-testid={`legal-acceptance-${variant}`}
    >
      <Trans
        t={t}
        i18nKey={VARIANT_KEYS[variant] || VARIANT_KEYS.continue}
        values={{ terms: t('common:legal.terms_label'), privacy: t('common:legal.privacy_label') }}
        components={{
          termsLink: <a key="termsLink" href={links.terms} target="_blank" rel="noopener noreferrer" className={linkClass} data-testid="legal-terms-link" />,
          privacyLink: <a key="privacyLink" href={links.privacy} target="_blank" rel="noopener noreferrer" className={linkClass} data-testid="legal-privacy-link" />,
        }}
      />
    </p>
  );
}
